import { SyntheticEvent, useState } from "react";
import { useSearchParams } from "react-router";
import { useTranslate } from "@refinedev/core";

const AGREEMENT_TAB_INDEX: Record<string, number> = {
  products: 2,
};

export function useAgreementForm() {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const initialTab =
    tabParam && tabParam in AGREEMENT_TAB_INDEX
      ? AGREEMENT_TAB_INDEX[tabParam]
      : 0;

  const [selectedTable, setSelectTable] = useState(initialTab);

  const translate = useTranslate();

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setSelectTable(newValue);
  };

  return {
    selectedTable,
    translate,
    handleChange,
  }
}
